import { ShieldCheck } from "lucide-react";
import { useT } from "../lib/i18n";

export const GdprFooter = () => {
  const t = useT();
  return (
    <footer
      className="h-8 shrink-0 flex items-center justify-between px-4 bg-[#06090E] border-t border-slate-800 overflow-hidden"
      data-testid="gdpr-footer-notice"
    >
      <p className="text-[9px] font-mono text-slate-500 tracking-wide truncate">{t.gdpr_text}</p>
      <span
        data-testid="eu-residency-badge"
        className="hidden sm:inline-flex items-center gap-1 shrink-0 px-2 py-0.5 rounded-full bg-teal-500/10 border border-teal-500/40 text-[9px] font-mono text-teal-300 tracking-wider mx-3"
        title={t.eu_hosted}
      >
        <ShieldCheck className="h-3 w-3" /> {t.eu_hosted}
      </span>
      <p
        className="hidden md:block text-[9px] font-mono text-slate-600 tracking-wide shrink-0 pl-4"
        data-testid="data-provenance-credits"
      >
        {t.gdpr_sources}
      </p>
    </footer>
  );
};
